<template>
  <div>
    <div class="table-page-search-wrapper">
    <a-form layout='inline' @keyup.enter.native='searchQuery'>
      <a-row :gutter='12'>
        <a-col :md='10' :sm='10'>
          <a-form-item :label="'日期'">
            <a-range-picker
              v-model='queryParam.queryDate'
              format='YYYY-MM-DD'
              style='width: 100%;' />
          </a-form-item>
        </a-col>
        <a-col :md='6' :sm='8'>
          <a-form-item :label="'类型'">
            <a-select
              v-model='queryParam.type'
            >
              <a-select-option value="payout">放款</a-select-option>
              <a-select-option value="repay">收款</a-select-option>
            </a-select>
          </a-form-item>
        </a-col>
        
        <a-col :md='6' :sm='8'>
            <span style='float: left;overflow: hidden;' class='table-page-search-submitButtons'>
                          <a-button type='primary' @click='searchQuery' icon='search'>{{ $t('search') }}</a-button>
                          <a-button type='primary' @click='searchReset' icon='reload' style='margin-left: 8px'>{{ $t('reset') }}</a-button>
            </span>
        </a-col>
      </a-row>
    </a-form>
    </div>
    <div>
      <a-row :gutter='12'>
        <a-col :md='12' :sm='8'>
      <template>
        <div>
          <span>新户</span><Pie :chart-data="datasourceNew" :chart-options="chartOptions" />

        </div>
      </template>
        </a-col>
        <a-col :md='12' :sm='8'>
      <template>
        <div>
          <span>老户</span><Pie :chart-data="datasourceOld" :chart-options="chartOptions" />
        </div>
      </template>
        </a-col>
      </a-row>
    </div>

  </div>
</template>


<script>

import { Pie } from 'vue-chartjs/legacy'

import {
  Chart as ChartJS,
  Title,
  Tooltip,
  Legend,
  ArcElement,
  CategoryScale
} from 'chart.js'


import { filterObj } from '@/utils/util'
import moment from 'moment'
import {
  groupApplyProductByDate,

} from '@/webpublicapi/statistics'

const I18N_KEY = {

}

ChartJS.register(Title, Tooltip, Legend, ArcElement, CategoryScale)

export default {
  name: 'groupApplyProductByDate',
  components: {
    Pie
  },
  data() {
    return {
      datasourceNew: {
        labels: [],
        datasets: [
          {
            backgroundColor: [],
            data: []
          }
        ]
      },
      datasourceOld: {
        labels: [],
        datasets: [
          {
            backgroundColor: [],
            data: []
          }
        ]
      },
      colorList : [
        "#FE8463","#F3A43B","#FAD860","#9BCA63",
        "#60C0DD",'#E52A1C',"#D7504B","#C6E579",
        "#F4E001","#F0805A","#26C0C0","#C1232B",
        "#B5C334","#FCCE10","#E87C25","#27727B"],
      queryParam: {
        queryDate: [moment(), moment()],
        appssid: undefined,
        type: "payout",
      },
      chartOptions: {
        responsive: true,
        maintainAspectRatio: false,
        plugins: {
          tooltip: {
            callbacks: {
              // label: function(context) {
              //   let label = context.dataset.label || '';
              //
              //   if (label) {
              //     label += ': ';
              //   }
              //   if (context.parsed.y !== null) {
              //     label += new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD' }).format(context.parsed.y);
              //   }
              //   return label;
              // }
              label: function(context) {
                console.log(context)
                let dataset = context.dataset;
                let value = dataset.data[context.dataIndex];
                let total = dataset.data.reduce(function(previousValue, currentValue) {
                  return previousValue + currentValue;
                });
                let percentage = ((value / total) * 100).toFixed(2) + "%";
                return context.label + ": " + percentage + "(" + value + ")";
              }
            }
          }
        }

      }
    }

  },

  computed: {

  },
  created() {
   // this.loadData(1)
  },
  methods: {
    searchQuery() {
      this.loadData(1)
    },
    transformTime(time) {
      return moment(time).format('YYYY-MM-DD')
    },
    loadData(arg) {

      let params = this.getQueryParams()// 查询条件

      groupApplyProductByDate(Object.assign({}, params)).then((res) => {
        if (res.code === 1000) {
          this.setData(res.data.new,1)
          this.setData(res.data.old,2)


        } else {
          this.$message.error(res.msg)
        }

      }).catch(e => {

        this.$message.error(e.message)
      })
    },
    setData(sourceData,type)
    {
      if(!sourceData)
        return

      sourceData = Object.values(sourceData)

      let targetData = {
        labels: [],
        datasets: [
          {
            backgroundColor: [],
            data: []
          }
        ]
      }

      let total = 0;
      for(let i=0; i<sourceData.length; i++)
      {
        total += sourceData[i].count
      }

      for(let i=0; i<sourceData.length; i++)
      {
        targetData.labels[i] = sourceData[i].product
        targetData.datasets[0].data[i] =  sourceData[i].count
        targetData.datasets[0].backgroundColor[i] = this.colorList[i]
      }

      type === 1 ? this.datasourceNew = targetData : this.datasourceOld = targetData

    },
    getQueryParams() {

      const { queryDate } = this.queryParam

      const data = {
        ...this.queryParam,//...将原始的this.queryParam对象中的属性复制到data对象中
        startDate: (queryDate && queryDate.length) ? this.transformTime(queryDate[0]) : undefined,
        endDate: (queryDate && queryDate.length) ? this.transformTime(queryDate[1]) : undefined
      }

      let param = this.queryParam

      param = Object.assign(data)

      return filterObj(param)
    },
    // 重置字典类型搜索框的内容
    searchReset() {
      let that = this
      that.queryParam.appssid = undefined
      that.queryParam.type = 'payout'
      that.queryParam.endDate = ''
      that.queryParam.startDate = ''
      that.queryParam.queryDate = [moment(), moment()]
    },

  }
}
</script>

<style lang='less' scoped>
@import "~@/assets/less/common.less";
</style>